const style = (theme): any => ({
    partnerInfo: {},
    partnerInfoLabel: {
        color: theme.palette.secondary.light,
    },
    card: {
        '& .MuiCardContent-root': {
            paddingBottom: 0,
        },
    },
    docsCtn: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    rightActions: {
        justifyContent: 'flex-end',
    },
});
export default style;
